import {useRedirect} from "./useRedirect";
import {useHistory} from "react-router-dom";
import {setCookie} from "../cookies";

export const useLogout = () => {
    const { setRedirect } = useRedirect();
    const { location } = useHistory();

    return () => {
        setRedirect(location.pathname + location.search);
        setCookie('filling_email_popup_shown', false);
    };
};